import { homeSeoContent } from '@/mocks/seoContent';

const ctaBgImage = 'https://readdy.ai/api/search-image?query=Wide%20panoramic%20flat%20lay%20of%20luxury%20fashion%20items%20spread%20across%20clean%20cream%20surface%20including%20designer%20sneakers%20leather%20tote%20bag%20folded%20silk%20scarf%20and%20minimalist%20accessories%20in%20warm%20neutral%20tones%2C%20soft%20natural%20lighting%20from%20above%2C%20editorial%20product%20photography%20with%20organic%20composition%20and%20generous%20negative%20space%20on%20sides&width=1920&height=900&seq=cta-v2-panorama-2026&orientation=landscape';

export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src={ctaBgImage}
          alt="VigorBuy Spreadsheet fashion finds"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-foreground-950/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-2xl">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-sans font-bold text-background-50 lowercase leading-none">
            {homeSeoContent.ctaHeading}
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-3.5 rounded-full bg-background-50 text-foreground-900 text-sm font-semibold cursor-pointer hover:bg-background-100 transition-colors duration-200 whitespace-nowrap self-start"
          >
            {homeSeoContent.ctaButton}
            <span className="w-6 h-6 rounded-full bg-foreground-900 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm text-background-50"></i>
            </span>
          </a>

          <p className="text-background-50/80 text-sm md:text-base max-w-xs leading-relaxed">
            {homeSeoContent.ctaDescription}
          </p>
        </div>
      </div>
    </section>
  );
}